/* js-cart-notification FIXED */

var CartNotification = {
  init: function () {
    if (window.__cartNotificationBound) return;
    window.__cartNotificationBound = true;

    const root = window.Shopify?.routes?.root || '/';

    /* -------------------------
       OPEN / CLOSE CART
    ------------------------- */

    $(document).off('click.cartNotification').on('click.cartNotification', 'a[href="#open-cart"]', function (e) {
      e.preventDefault();
      history.pushState(null, null, ' ');
      openCart();
    });

    $(document).off('click.cartNotificationClose').on('click.cartNotificationClose', '.button-close-cart', closeCart);

    $(document).off('keydown.cartNotification').on('keydown.cartNotification', function (e) {
      if (e.key === 'Escape' && $('.cart-notification').hasClass('cart-notification-active')) {
        closeCart();
      }
    });

    function openCart() {
      $('.cart-notification')
        .addClass('cart-notification-active')
        .attr('aria-hidden', 'false');
      $('body').addClass('cart-notification-open');
    }

    function closeCart() {
      $('.cart-notification')
        .removeClass('cart-notification-active')
        .attr('aria-hidden', 'true');
      $('body').removeClass('cart-notification-open');
    }

    /* -------------------------
       ADD TO CART
    ------------------------- */

    $(document).off('click.cartNotificationAdd').on('click.cartNotificationAdd', '.button-add-cart', function (e) {
      e.preventDefault();
      const $btn = $(this);

      if (
        $btn.hasClass('product-unavailable') ||
        $btn.hasClass('product-adding') ||
        $btn.prop('disabled')
      ) {
        return;
      }

      const productID = Number($btn.attr('data-id'));
      const productParent = $btn.data('parent');
      const randomID = Math.floor(Math.random() * 1e9);

      let productQty = Math.max(
        1,
        parseInt($btn.closest('.add-cart-wrapper').find('input[name="quantity"]').val(), 10) ||
          parseInt($('.product_data input[name="quantity"]').first().val(), 10) ||
          1
      );

      // 🚨 Validació crítica
      if (!productID || isNaN(productID)) {
        console.error('❌ Variant ID invàlid:', $btn.attr('data-id'));
        return;
      }

      $btn.addClass('product-adding');

      const items = [];

      /* --- ADDONS --- */
      $('#product_data [name="product_addon"], .product_data [name="product_addon"]').each(function () {
        const $addon = $(this);

        const qty = parseInt($addon.find('[name="quantity"]').val(), 10) || 0;
        if (qty <= 0) return;

        const propName = $addon.find('[name="property"]').data('name');
        const propValue = $addon.find('[name="property"]').data('value');

        const properties = { _link: randomID };

        if (propName) properties[propName] = propValue;

        items.push({
          id: Number($addon.data('id')),
          quantity: qty,
          properties
        });
      });

      /* --- PROPERTIES PRODUCTE PRINCIPAL --- */
      const properties = { _parent: productParent };

      $('#product_data [name="product_property"], .product_data [name="product_property"]').each(function () {
        const propName = $(this).data('name');
        const propValue = $(this).data('value');

        if (propName) properties[propName] = propValue;
      });

      if (items.length) {
        properties._mlink = randomID;
      }

      /* --- PRODUCTE PRINCIPAL --- */
      items.push({
        id: productID,
        quantity: productQty,
        properties
      });

      addToCart(
        {
          items,
          sections: ['section-cart-notification']
        },
        $btn
      );
    });

    /* -------------------------
       AJAX ADD TO CART
    ------------------------- */

    function addToCart(payload, $btn) {
      const body = {
        items: payload.items || [],
        sections: Array.isArray(payload.sections)
          ? payload.sections
          : ['section-cart-notification'],
        sections_url: window.location.pathname
      };

      $.ajax({
        url: root + 'cart/add.js',
        method: 'POST',
        data: JSON.stringify(body),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      })
        .done(function (data) {
          updateCartNotificationHTML(data);
          openCart();
        })
        .fail(function (xhr) {
          const msg =
            xhr?.responseJSON?.description ||
            xhr?.responseJSON?.message ||
            'Error afegint el producte.';

          alert(msg);

          console.error('ADD TO CART ERROR:', {
            status: xhr.status,
            response: xhr.responseJSON || xhr.responseText
          });
        })
        .always(function () {
          if ($btn) $btn.removeClass('product-adding');
        });
    }

    CartNotification.addToCart = addToCart;

    /* -------------------------
       UPDATE CART HTML
    ------------------------- */

    function updateCartNotificationHTML(data) {
      const html = data?.sections?.['section-cart-notification'];

      if (!html) {
        console.warn('⚠️ No sections returned', data);
        openCart();
        updateCartTotals();
        return;
      }

      const $cartEl = $('.cart-notification__products');

      $cartEl.empty().append($(html).html());

      bindCartEvents();
      updateCartTotals();
    }

    /* -------------------------
       REMOVE ITEM
    ------------------------- */

    function removeFromCart($item) {
      if ($item.data('line') === 'removed') return;

      const changes = [{ line: $item.data('line'), quantity: 0 }];
      $item.data('line', 'removed');

      const mlink = $item.data('mlink');

      if (mlink) {
        $('.cart-notification__products__item').each(function () {
          const $linked = $(this);

          if ($linked.data('link') == mlink && $linked.data('line') !== 'removed') {
            changes.push({
              line: $linked.data('line'),
              quantity: 0
            });

            $linked.data('line', 'removed');
          }
        });
      }

      const doChanges = (list) => {
        if (!list.length) {
          afterRemove();
          return;
        }

        $.post(root + 'cart/change.js', list[0], null, 'json')
          .always(() => doChanges(list.slice(1)));
      };

      doChanges(changes);
    }

    function afterRemove() {
      $('.cart-notification__products__item[data-line="removed"]').fadeOut(200, function () {
        $(this).remove();
        updateCartTotals();
      });

      updateCartTotals();
    }

    /* -------------------------
       EVENTS (ITEMS)
    ------------------------- */

    function bindCartEvents() {
      const $items = $('.cart-notification__products__item');

      /* REMOVE */
      $items.find('.btn-remove').off('click').on('click', function () {
        removeFromCart($(this).closest('.cart-notification__products__item'));
      });

      /* PLUS */
      $items.find('.plus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        if ($input[0]) $input[0].stepUp();
        $input.trigger('change');
      });

      /* MINUS */
      $items.find('.minus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        if ($input[0]) $input[0].stepDown();
        $input.trigger('change');
      });

      /* CHANGE QTY */
      $items
        .find('.cart-notification__products__item__quantity')
        .off('change')
        .on('change', function () {
          const $input = $(this);
          const $item = $input.closest('.cart-notification__products__item');

          const line = $item.data('line');
          const newQty = parseInt($input.val(), 10) || 0;

          $.post(root + 'cart/change.js', { line, quantity: newQty }, null, 'json')
            .fail(function () {
              alert('No hi ha prou estoc disponible.');
              $input.val($input.attr('data-qty'));
            })
            .always(updateCartTotals);
        });
    }

    /* -------------------------
       TOTALS
    ------------------------- */

    function updateCartTotals() {
      let totalQty = 0;
      let totalAmount = 0;

      $('.cart-notification__products__item').each(function () {
        const $item = $(this);

        if ($item.data('line') === 'removed') return;

        const qty =
          parseInt(
            $item.find('.cart-notification__products__item__quantity').val(),
            10
          ) || 1;

        const price =
          parseFloat($item.find('[data-price]').data('price')) || 0;

        totalQty += qty;
        totalAmount += qty * price;
      });

      $('.cart-notification__price').html(formatMoney(totalAmount));

      $('.num-cart, .header__options__buttons__item .counter').html(totalQty);

      if (totalQty === 0) {
        $('.cart-empty').css('display', 'flex');
        $('.cart-notification__content').css('display', 'none');
      } else {
        $('.cart-empty').css('display', 'none');
        $('.cart-notification__content').css('display', 'flex');
      }
    }

    /* INIT */
    updateCartTotals();
    bindCartEvents();
  }
};

CartNotification.init();